// extracted by mini-css-extract-plugin
export default {"wrapper":"SayInternal_wrapper__kK1IO"};